import "./styles.scss";

import { useState } from "react";

import Tabs from "../../components/Tabs";
import Privileges from "./components/Privileges";
import Disclosure from "./components/Disclosure";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import affiliateIcon from "../../assets/images/icons/icon_affiliate_header.svg";

const options = ["PRIVILEGES", "DISCLOSURE"];

function SettingsAffiliate() {
  const [activeTab, setActiveTab] = useState("PRIVILEGES");

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          typeIcon="custom"
          title="Affiliates"
          icon={<img src={affiliateIcon} alt="affiliateIcon" />}
          rightButton={options[1] === activeTab ? <div id="renderButtonDisclosure" /> : null}
        />

        <Tabs options={options} activeTab={activeTab} setActiveTab={setActiveTab}>
          {options[0] === activeTab && <Privileges />}
          {options[1] === activeTab && <Disclosure />}
        </Tabs>
      </section>
    </div>
  );
}

export default SettingsAffiliate;
